import _ from 'lodash';
import ApplicationConstants from '../constants/ApplicationConstants.js';
import {RollOverTypes} from '../constants/FundingYourProductConstants.js';
import DownloadConstants from '../constants/DownloadConstants.js';
import Products from '../utils/Products.js';

const ProductIds = ApplicationConstants.ProductIds;
const DownloadableForms = DownloadConstants.DownloadableForms;
const AccountTypes = ApplicationConstants.AccountTypeCodes;
const AdviserForms = DownloadConstants.AdviserForms;

function getFormsList(productId, accountType) {
    let result = [];
    switch (productId) {
        case ProductIds.SUPER:
            result = _.cloneDeep(DownloadableForms.SUPER);
            break;
        case ProductIds.PENSION:
            result = _.cloneDeep(DownloadableForms.PENSION);
            break;
        case ProductIds.INVESTMENT:
            switch (accountType) {
                case AccountTypes.INDIVIDUAL:
                case AccountTypes.SOLE_TRADER:
                    result = _.cloneDeep(DownloadableForms.INDIVIDUAL);
                    break;
                case AccountTypes.JOINT:
                    result = _.cloneDeep(DownloadableForms.JOINT);
                    break;
                case AccountTypes.COMPANY:
                    result = _.cloneDeep(DownloadableForms.COMPANY);
                    break;
                case AccountTypes.PARTNERSHIP:
                    result = _.cloneDeep(DownloadableForms.PARTNERSHIP);
                    break;
                case AccountTypes.SMSF:
                    result = _.cloneDeep(DownloadableForms.SMSF);
                    break;
                case AccountTypes.TRUST:
                    result = _.cloneDeep(DownloadableForms.TRUST);
                    break;
                default:
                    result = [];
                    break;
            }
            break;
        default:
            result = [];
            break;
    }
    result = performAdviserCheck(result);
    return result;
}

function performAdviserCheck(list) {
    let userContext = {};
    if (window && window.NOA && window.NOA.userContext) {
        userContext = window.NOA.userContext;
    }
    if (!userContext.isAdviser && list.length > 0) {
        _.remove(list, function(data) {
            return data.value === AdviserForms.INDIVIDUAL2 ||
                data.value === AdviserForms.INDIVIDUAL5 ||
                data.value === AdviserForms.ORGANIZATION5;
        });
    }
    return list;
}

function getSelectedForms(formsToDownload) {
    let results = [];
    if (!formsToDownload || formsToDownload.length == 0) {
        return results;
    }
    let selectedForms = _.cloneDeep(formsToDownload);
    selectedForms = _.where(selectedForms, {'checked': true});
    if (selectedForms && selectedForms.length > 0) {
        results = _.pluck(selectedForms, 'value');
    }
    return results;
}

function createDownloadData(obj) {
    if (_.isEmpty(obj) || !obj) {
        return {};
    }

    return {
        content: obj.content.downloadMenu,
        productId: obj.product.value,
        enableDownloadButton: obj.enableDownloadButton,
        formsToDownload: obj.formsToDownload,
        downloadInProgress: obj.downloadInProgress,
        selectedForms: obj.selectedForms,
        readyForDownload: obj.readyForDownload,
        downloadFormsFailed: obj.downloadFormsFailed,
        downloadedForms: obj.downloadedForms,
        formDownloaded: obj.formDownloaded
    };
}

function getInSpecieInvestmentOptions(inSpecieAccount) {
    if (!inSpecieAccount) {
        return [];
    }

    if (inSpecieAccount.rollOverType === RollOverTypes.INTERNAL && inSpecieAccount.investmentOptions) {
        // filter out internal accounts with zero balance for inSpecies
        return _.filter(inSpecieAccount.investmentOptions,
            function(inv) {
                return parseFloat(inv.balance) > 0;
            });
    }

    return inSpecieAccount.investmentOptions;
}

function getDownloadFormApplication(application) {
    // The Investment Allocations appears in pdf is a list of all invetment options from inspecie accounts 
    // and user input in investment allocation but the weight is the user input only. 
    if (!application) {
        return null;
    }

    let downloadApplication = _.cloneDeep(application);
    let downloadInvestmentOptions = _.get(downloadApplication, 'form.investmentAllocation.investmentOptions', []);
    const isInSpecie = _.get(application, 'form.inSpecieTransfer.setUp', null) === ApplicationConstants.YesNoValues.YES &&
        Products.isPension(application.productId);
    const inSpecieAccounts = _.get(downloadApplication, 'form.inSpecieTransfer.inSpecieAccounts', []);
    const investmentOptionsForInSpecie =  isInSpecie && inSpecieAccounts.length > 0 ?
        _.flatten(_.map(inSpecieAccounts, getInSpecieInvestmentOptions)) : [];

    _.each(investmentOptionsForInSpecie,
        invOptionInspecie => {
            if (!_.some(downloadInvestmentOptions, { id: invOptionInspecie.id })) {
                downloadInvestmentOptions.push(invOptionInspecie);
            }
        });
    
    _.set(downloadApplication, 'form.investmentAllocation.investmentOptions', downloadInvestmentOptions);

    return downloadApplication;
}

const DownloadFormsHelper = {
    getFormsList: getFormsList,
    getSelectedForms: getSelectedForms,
    createDownloadData: createDownloadData,
    getDownloadFormApplication: getDownloadFormApplication
};

export default DownloadFormsHelper;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/DownloadFormsHelper.js